import React from 'react';
import { Grid } from '@mui/material';
import { noTopGutterSx } from 'src/UIKit';
import { KeywordsField } from '../../fields';
import { FieldWithProperties } from '../../FieldWithProperties';
import { SectionProps } from '../../../registry/sectionRegistry';

/**
 * Keywords field + its Visible/Required/Label properties.
 * Bound to config.keywords. Used by join / enrollment / text_to_win.
 */
export const KeywordsSection: React.FC<SectionProps> = ({
  config,
  onConfigUpdate,
  options,
  selected,
  onSelect,
}) => {
  const keywords = config.keywords;

  const update = (patch: Partial<typeof keywords>) =>
    onConfigUpdate({
      keywords: {
        ...keywords,
        values: keywords?.values || [],
        visible: keywords?.visible || false,
        required: keywords?.required || false,
        ...patch,
      },
    });

  // Keywords are backend-mandated for these types — lock the toggles.
  const beRequired = config.type === 'join' || config.type === 'enrollment' || config.type === 'text_to_win';

  return (
    <Grid item xs={12} sx={noTopGutterSx}>
      <FieldWithProperties
        visible={keywords?.visible ?? false}
        required={keywords?.required ?? false}
        hideToggles={beRequired}
        label={keywords?.label}
        onVisibleChange={visible => update({ visible })}
        onRequiredChange={required => update({ required })}
        onLabelChange={label => update({ label })}
        field={
          <KeywordsField
            values={keywords?.values || []}
            onChange={values => update({ values })}
            visible={keywords?.visible || false}
            required={keywords?.required || false}
            isSelected={!!selected}
            onClick={() => onSelect?.()}
            label={keywords?.label}
            options={options?.keywords || []}
          />
        }
      />
    </Grid>
  );
};
